import React from 'react';
import classNames from 'classnames';
import { useTPAComponentsConfig } from '../TPAComponentsProvider';
import styles from './TextButton.module.scss';
/** Mirrors `TextButtonPriority` from `wix-ui-tpa/cssVars` (types.js) — all four values. */
export const TextButtonPriority = {
    primary: 'primary',
    secondary: 'secondary',
    link: 'link',
    primaryLink: 'primaryLink',
};
/**
 * Drop-in replacement for `TextButton` from `wix-ui-tpa/cssVars`.
 *
 * Matches WUT's component, not just its stylesheet:
 *
 *  - `priority` defaults to `link` (`TextButton.js`), NOT `primary`: a call site that omits the
 *    prop gets the link colour and an underline.
 *  - it renders CoreButtonNext, whose DOM is `<button><span class="content">…</span></button>`;
 *    without that span every `.content` rule upstream has nothing to match.
 *  - `hoverStyle` has NO default upstream, so the state is absent unless a caller passes one.
 *  - `data-priority` / `data-mobile` are emitted as WUT does, for consumer stylesheets.
 */
export const TextButton = React.forwardRef(({ className, priority = TextButtonPriority.link, hoverStyle, mobile: mobileProp, type = 'button', children, ...rest }, ref) => {
    /*
     * `mobile` comes from TPAComponentsContext when the caller does not pass it: `@wix/
     * yoshi-flow-editor` wraps every widget in WUT's own `TPAComponentsProvider`, so every WUT
     * component in this app received it for free, while these ports took a prop nothing passed and
     * stayed permanently on their desktop branch. A prop still wins.
     */
    const tpaConfig = useTPAComponentsConfig();
    const mobile = mobileProp ?? tpaConfig.mobile ?? false;
    return (React.createElement("button", { ...rest, ref: ref, type: type, "data-priority": priority, "data-mobile": mobile, className: classNames(styles.root, styles[priority], hoverStyle ? styles[`hover-${hoverStyle}`] : undefined, { [styles.mobile]: mobile }, className) },
        React.createElement("span", { className: styles.content }, children)));
});
TextButton.displayName = 'TextButton';
//# sourceMappingURL=TextButton.js.map